import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Router } from "@angular/router";
import { Role } from '../../models/shared/role.model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class RoleService {
  private service = "api/RoleManagement"; //Controller Name
  public roleList: Role[];

  constructor(private http: Http, private readonly router: Router, private cookieService: CookieService) { }

  GetRoles() {
    return this.http.get(`${this.service}`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler)
  }

  GetActiveRoles() {
    return this.http.get(`${this.service}/GetActiveRoles`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler)
  }

  AddRole(role: Role): void {
    this.http
      .post(`${this.service}`, role, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .subscribe(result => {
        this.router.navigate(["/role-list"]);
      });
  }
  UpdateRole(role: Role): void {
    this.http
      .put(`${this.service}`, role, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .subscribe(result => {
        this.router.navigate(["/role-list"]);
      });
  }
  GetRoleById(id: string) {
    return this.http.get(`${this.service}/` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => <Role>response.json())
      .catch(this.errorHandler);
  }
  DeleteRole(id: string) {
    return this.http.delete(`${this.service}/` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => <Role>response.json())
      .catch(this.errorHandler);
  }
  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/role/role.service.ts